<template>
  <master-main
    ref="masterMain"
    :addProperties="{ eventType: 1, routeToCreate: getModuleRoute }"
    :exportProperties="{
      pdf: {
        filename: `${$t('devices.blood_pressure_monitors')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('devices.blood_pressure_monitors')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.company'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
      {
        columnLabel: $t('common_words.farm'),
        data: 'farms',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
  />
</template>

<script>
import { getDateToday } from 'src/util/Util';
import BloodPressureMonitorTable from './blood-pressure-monitor-table';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';

export default {
  components: { MasterMain },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinMenu,
    MixinRerender,
  ],
  data() {
    return { tableProperties: {}, showProperties: { size: '60%' } };
  },
  computed: {
    getModuleRoute() {
      return 'devices/bloodpressuremonitors';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...BloodPressureMonitorTable().tableColumns],
        model: 'blood_pressure_monitors',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
      };
    },
  },
};
</script>
